<div class="ld-root">

  <!-- Canvas partículas -->
  <canvas #ldCanvas class="ld-canvas"></canvas>

  <!-- Loading overlay -->
  <div *ngIf="(loginFacade.responseLoading$ | async)?.loading" class="ld-loading">
    <div class="ld-spin-wrap">
      <div class="ld-comet"></div>
      <p class="ld-spin-lbl">Verificando credenciales...</p>
    </div>
  </div>

  <!-- Card split layout -->
  <div class="ld-card">

    <!-- Panel izquierdo: Branding -->
    <div class="ld-brand">
      <div class="ld-brand-content">

        <div class="ld-left-top">
          <span class="ld-chip">
            <span class="ld-chip-dot"></span>
            Inicio de Sesión
          </span>
        </div>

        <div class="ld-illustration">
          <img src="../../../assets/images/Opciones/admisiones.png"
               alt="Ilustración" draggable="false">
        </div>

        <div class="ld-left-bottom">
          <h2 class="ld-left-title">PORTAL DSA · Comisiones</h2>
          <p class="ld-left-sub">Dirección del Sistema de Estudios de Posgrado &middot; UNAH</p>
        </div>

      </div>
    </div>

    <!-- Panel derecho: Formulario -->
    <div class="ld-panel">
      <div class="ld-panel-bar"></div>

      <div class="ld-panel-inner">

        <img src="../../../assets/images/logo/logo-unah.png" alt="UNAH" class="ld-logo" draggable="false">

        <!-- Paso 1: elegir tipo de usuario -->
        <ng-container *ngIf="!tipoUsuario">

          <div class="ld-form-head">
            <h1 class="ld-form-title">DSA &middot; Comisiones</h1>
            <p class="ld-form-sub">
              <mat-icon class="ld-sub-icon">how_to_reg</mat-icon>
              Selecciona cómo vas a ingresar
            </p>
          </div>

          <div class="ld-tipo-grid">
            <button type="button" class="ld-tipo-card" (click)="seleccionarTipo(1)">
              <span class="ld-tipo-icon"><mat-icon>work</mat-icon></span>
              <span class="ld-tipo-titulo">Empleado</span>
              <span class="ld-tipo-desc">Personal empleado de la UNAH</span>
            </button>

            <button type="button" class="ld-tipo-card" (click)="seleccionarTipo(2)">
              <span class="ld-tipo-icon"><mat-icon>school</mat-icon></span>
              <span class="ld-tipo-titulo">Estudiante</span>
              <span class="ld-tipo-desc">Miembro de comisión estudiantil</span>
            </button>
          </div>

          <div class="ld-actions ld-actions-solo">
            <button mat-button type="button" class="ld-btn-back" (click)="volver()">
              <mat-icon>arrow_back_ios</mat-icon> Volver
            </button>
          </div>

        </ng-container>

        <!-- Paso 2: formulario de credenciales -->
        <ng-container *ngIf="tipoUsuario">

          <div class="ld-tipo-chip-row">
            <button type="button" class="ld-tipo-chip" (click)="cambiarTipo()">
              <mat-icon>{{ tipoUsuario === 1 ? 'work' : 'school' }}</mat-icon>
              {{ tipoUsuario === 1 ? 'Empleado' : 'Estudiante' }}
              <mat-icon class="ld-tipo-chip-edit">edit</mat-icon>
            </button>
          </div>

          <div class="ld-form-head">
            <h1 class="ld-form-title">DSA &middot; Comisiones</h1>
            <p class="ld-form-sub">
              <mat-icon class="ld-sub-icon">shield</mat-icon>
              {{ tipoUsuario === 2
                ? 'Ingresa tu número de cuenta y contraseña de registro'
                : 'Ingresa tus credenciales de correo institucional' }}
            </p>
          </div>

          <form ngNativeValidate [formGroup]="formLogin" (ngSubmit)="login()" class="ld-form">

            <mat-form-field appearance="outline" class="ld-field">
              <mat-label>Usuario</mat-label>
              <input matInput formControlName="usuario" required autocomplete="off"
                (keydown.enter)="$event.preventDefault()">
              <mat-icon matSuffix>badge</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" class="ld-field">
              <mat-label>Contraseña</mat-label>
              <input matInput [type]="hide ? 'password' : 'text'"
                formControlName="password" required autocomplete="off">
              <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                [attr.aria-label]="'Mostrar contraseña'" [attr.aria-pressed]="hide">
                <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </mat-form-field>

            <div class="ld-forgot">
              <span (click)="redirectToForgotPassword()">¿Olvidaste tu contraseña?</span>
            </div>

            <div class="ld-actions">
              <button mat-button type="button" class="ld-btn-back" (click)="cambiarTipo()">
                <mat-icon>arrow_back_ios</mat-icon> Volver
              </button>
              <button mat-raised-button type="submit" class="ld-btn-submit"
                [disabled]="(loginFacade.responseLoading$ | async)?.loading">
                <ng-container *ngIf="!(loginFacade.responseLoading$ | async)?.loading; else ldLoadTpl">
                  Ingresar &nbsp;<mat-icon>east</mat-icon>
                </ng-container>
                <ng-template #ldLoadTpl>
                  <mat-spinner diameter="22" strokeWidth="3"></mat-spinner>
                </ng-template>
              </button>
            </div>

          </form>

        </ng-container>

        <p class="ld-footer">UNAH &copy; {{ year }} &middot; Portal de Posgrados</p>
      </div>
    </div>

  </div>

</div>
